import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Form, Row, Container, Card } from "react-bootstrap";
import { Formik } from "formik";
import InputText from "../../components/common/InputText";
import InputTextArea from "../../components/common/TextArea";
import storage from "../../helpers/storage";
import Loader from "../../components/common/Loader";
import { toast } from "react-toastify";
import { ContactUsSchema } from "validations/Sites";
import { contactUsQuery } from "services/contactUs";
import EmailIcon from "../../assets/images/email.svg";
import PhoneIcon from "../../assets/images/contact-phone.svg";
import ContactUsMap from "./ContactUsMap";
import { nameBasedProtectedRoutes } from "router/protected";
import ReCAPTCHA from "react-google-recaptcha";
import { MESSAGES } from "constants/messages";

export const ContactUs = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [captchaCode, setCaptchaCode] = useState("");
  const recaptchaRef = useRef<any>(null);

  const userInformation: any = storage.getData("user-info");
  const email = userInformation.email;
  const name = userInformation.first_name + " " + userInformation.last_name;
  let initialValues = {
    email: email ? email : "",
    name: name ? name : "",
    subject: "",
    description: "",
  };

  useEffect(() => {}, []);

  // Submit the form data and sent mail to admin
  const handleSubmit = async (values: any, { resetForm }) => {
    if (!captchaCode) {
      toast.error(MESSAGES.captchInvalid);
      return;
    }
    setLoading(true);
    let formData = {
      name: name ? name : values.name,
      email: email ? email : values.email,
      subject: values.subject,
      description: values.description,
    };

    const result = contactUsQuery(formData)
      .then((response) => {
        setLoading(false);
        resetForm();
        toast.success(response?.message);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  // Set value of captcha code
  const onChangeCaptchaCode = (value: any) => {
    setCaptchaCode(value);
  };

  return (
    <section className="profile-main pt-4 dashboard-content faq-content">
      <Container className="">
        <Row>
          <Col md={6} lg={6}>
            <h1 className="fs-30 fw-bold mb-1 mt-2">Contact Us</h1>
            <p className="fs-15 ">Submit your questions or comments below.</p>
          </Col>
          <Col
            md={6}
            lg={6}
            className="align-items-center col-lg-6 col-md-6 d-flex justify-content-xl-end  mb-lg-0 mb-3 flex-wrap"
          >
            <div className="align-items-center d-flex me-5">
              <div className="me-3">
                <img src={EmailIcon} />
              </div>
              <div className="">
                <div className="fs-18 fw-bold ">Address</div>
                <div className="fs-13">P.O. Box 726 Niantic, CT 06357</div>
              </div>
            </div>

            <div className="align-items-center d-flex me-5">
              <div className="me-3">
                <img src={PhoneIcon} />
              </div>
              <div className="">
                <div className="fs-18 fw-bold ">Phone</div>
                <div className="fs-13">(860) 739-4446</div>
              </div>
            </div>
            <div className="align-items-center d-flex">
              <div className="me-3">
                <img src={EmailIcon} />
              </div>
              <div className="">
                <div className="fs-18 fw-bold ">Email</div>
                <div className="fs-13">info@hesco.com</div>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-4 ">
          <Formik
            validationSchema={ContactUsSchema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
              setFieldError,
              setValues,
              resetForm,
            }) => (
              <Form className="pe-xl-3" noValidate onSubmit={handleSubmit}>
                <Row>
                  <Col md={7} lg={7}>
                    <Card className="border-0 mb-3 contact-form">
                      <Card.Body className="br-10 p-4">
                        <div className="col-xl-12">
                          <Row>
                            <Col md="12">
                              <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-4 text-uppercase">
                                GET IN TOUCH WITH US
                              </h2>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="12">
                              <InputText
                                controlId="email"
                                label="Email"
                                placeholder="Email"
                                touched={touched.email}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                errorsField={errors.email}
                                value={values.email}
                                disabled={true}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <InputText
                                controlId="name"
                                label="Name"
                                placeholder="Name"
                                touched={touched.name}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                errorsField={errors.name}
                                value={values.name}
                                disabled={true}
                              />
                            </Col>
                            <Col lg="6">
                              <InputText
                                controlId="subject"
                                label="Subject"
                                placeholder="Subject"
                                touched={touched.subject}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                errorsField={errors.subject}
                                value={values.subject}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="12">
                              <InputTextArea
                                controlId="description"
                                label="Description"
                                placeholder="Description"
                                touched={touched.description}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                errorsField={errors.description}
                                value={values.description}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={process.env.REACT_APP_CPATCHA_KEY}
                                onChange={onChangeCaptchaCode}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Card.Body>
                    </Card>
                    <Row>
                      <Col sm="12" className="d-flex justify-content-end">
                        <Link
                          to={nameBasedProtectedRoutes.dashborad.path}
                          className="btn btn-light my-1 fw-semibold me-2"
                        >
                          Cancel
                        </Link>
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn btn-primary my-1 fw-semibold"
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={5} lg={5}>
                    <ContactUsMap />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Row>
      </Container>
      <Loader isLoading={loading} />
    </section>
  );
};
